module.exports = __webpack_public_path__ + "media/assets/icons/check-alt-056620ff5beec6be6701152b40b680e1.svg";